import { notification } from 'antd';
import { CheckOutlined, CloseOutlined, InfoCircleOutlined, WarningOutlined } from '@ant-design/icons';
import { metaTones } from 'theme/brandTokens';

// Sourced from the canonical metaTones (previously a divergent local palette)
// so notification colours match the rest of the platform's status surfaces.
const SEMANTIC = {
	success: {
		border: metaTones.success.border,
		bg: metaTones.success.background,
		color: metaTones.success.color,
		icon: <CheckOutlined />
	},
	error: {
		border: metaTones.danger.border,
		bg: metaTones.danger.background,
		color: metaTones.danger.color,
		icon: <CloseOutlined />
	},
	warning: {
		border: metaTones.warning.border,
		bg: metaTones.warning.background,
		color: metaTones.warning.color,
		icon: <WarningOutlined />
	},
	info: {
		border: metaTones.info.border,
		bg: metaTones.info.background,
		color: metaTones.info.color,
		icon: <InfoCircleOutlined />
	}
};

const IconDot = ({ type }) => {
	const s = SEMANTIC[type] || SEMANTIC.info;
	return (
		<div
			style={{
				width: 20,
				height: 20,
				borderRadius: '50%',
				background: s.bg,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				flexShrink: 0,
				fontSize: 11,
				color: s.color
			}}
		>
			{s.icon}
		</div>
	);
};

let noticeSeq = 0;

// A fixed `key` replaces the open notice with that key instead of stacking a new one.
const createNotification = (
	type,
	message,
	description,
	placement = 'topRight',
	key = `zz-notification-${noticeSeq++}`
) => {
	const s = SEMANTIC[type] || SEMANTIC.info;
	// antd positions its close button absolutely for the default 20px/24px
	// notice padding, which misaligns against our shrunken 12px/14px padding
	// (worst on title-only notices). Render our own close inside the title
	// row instead so flexbox keeps it centred regardless of content.

	notification.open({
		key,
		message: (
			<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
				<IconDot type={type} />
				<span style={{ flex: 1, fontSize: 13, fontWeight: 500, lineHeight: '20px' }}>{message}</span>
				<CloseOutlined
					onClick={() => notification.destroy(key)}
					style={{
						fontSize: 11,
						color: 'rgba(0,0,0,0.35)',
						cursor: 'pointer',
						padding: 4,
						flexShrink: 0
					}}
				/>
			</div>
		),
		description: description ? <span style={{ fontSize: 12, marginLeft: 30 }}>{description}</span> : null,
		placement,
		duration: type === 'error' ? 5 : 3,
		icon: null,
		style: {
			padding: '12px 14px',
			borderRadius: 10,
			boxShadow: 'none',
			border: '0.5px solid rgba(0,0,0,0.08)',
			borderLeftWidth: 3,
			borderLeftColor: s.border,
			borderLeftStyle: 'solid'
		},
		closeIcon: false
	});
};

export default createNotification;
